import React, { Component } from 'react';
import {Button, TextField} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import { authUtil } from '../../../../utils';

export class LanguageGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedLanguages: Array.isArray(props.initialValue)
        ? props.initialValue : props.initialValue ? [props.initialValue] : [],
      searchString: ''
    };
  }

  componentDidMount() {
    this.fetchLanguageOptions();
  }

  fetchLanguageOptions = async (lng = 'en') => {
    const idToken = await authUtil.getFreshIdToken();
    fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/global/languages?lng=${lng}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'br-token': idToken
      }
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.error);
        }
        return res.json();
      })
      .then((languageOptions) => {
        if (languageOptions) {
          this.setState({
            languageOptions
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        // done
      });
  }

  handleLanguageChange = (language, checked) => {
    this.setState(state => ({
      selectedLanguages: checked
        ? [...state.selectedLanguages, language]
        : state.selectedLanguages.filter(value => value !== language)
    }), () => {
      const { autoUpdate } = this.props;
      if (autoUpdate) this.submit();
    });
  }

  submit = () => {
    const { selectedLanguages, languageOptions } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate(selectedLanguages,
        (languageOptions || []).filter(option => selectedLanguages.includes(option.value)))
    }
  }

  // render
  render() {
    const {
      t, updating, wizardMode, header, subheader, autoUpdate, compact
    } = this.props;
    const { selectedLanguages, languageOptions, searchString } = this.state;
    const visibleOptions = (languageOptions || []).filter(option =>
      option.text.toLowerCase().includes(searchString.toLowerCase()));
    const choices = (
      <>
        <TextField label={t('Filter')} value={searchString}
          onChange={event => this.setState({searchString: event.target.value})} />
        <fieldset disabled={updating} style={{border: 0, padding: 0, margin: 0,
          maxHeight: compact ? 180 : 300, overflowY: 'auto'}}>
          <legend>{t('Languages')}</legend>
          {visibleOptions.map(option => (
            <label key={option.key || option.value}
              style={{display: 'flex', alignItems: 'center', gap: 8, padding: '0.25em 0'}}>
              <input type='checkbox' checked={selectedLanguages.includes(option.value)}
                onChange={event => this.handleLanguageChange(option.value, event.target.checked)} />
              <span>{option.text}</span>
            </label>
          ))}
        </fieldset>
      </>
    );
    if (compact) return choices;
    return (
      <div>
        <h2>{header || t('WhichLanguagesDoYouRead')}</h2>
        {subheader !== false && <p>{subheader || t('OnYourProfile')}</p>}
        {languageOptions && choices}
        {!autoUpdate && languageOptions && (
          <Button style={{marginTop: '1em'}} onClick={this.submit}
            disabled={updating || (wizardMode && selectedLanguages.length === 0)}
            aria-busy={updating}>
            {t('Save')}
          </Button>
        )}
      </div>
    );
  }
}

export default withTranslation()(LanguageGetter)
